"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.neighbourhoodReducer = void 0;
var PlaceAction_1 = require("@/pages/place/actions/PlaceAction");
var NeighbourhoodInfo_init_1 = require("@/pages/place/states/NeighbourhoodInfo.init");
var typesafe_actions_1 = require("typesafe-actions");
var neighbourhoodReducer = function (state, action) {
    if (state === void 0) { state = NeighbourhoodInfo_init_1.defaultNeighbourhoodInfoState; }
    switch (action.type) {
        case typesafe_actions_1.getType(PlaceAction_1.default.setNeighbourhoodGroupActive): {
            return __assign(__assign({}, state), { active: action.payload });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.setNeighbourMobileFilter): {
            return __assign(__assign({}, state), { mobileActive: action.payload });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.setNeighbourFilterType): {
            return __assign(__assign({}, state), { activeType: action.payload });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.setSubitems): {
            var type_1 = action.payload.type;
            var items_1 = action.payload.items;
            var groupIndex_1 = state.groups.findIndex(function (it) {
                return it.items.findIndex(function (it2) { return it2.type === type_1; }) > -1;
            });
            var newGroups = state.groups.map(function (it, index) {
                if (index !== groupIndex_1)
                    return it;
                var newGroupItems = it.items.map(function (it) {
                    if (it.type !== type_1)
                        return it;
                    return __assign(__assign({}, it), { children: items_1 });
                });
                return __assign(__assign({}, it), { items: newGroupItems });
            });
            return __assign(__assign({}, state), { groups: newGroups });
        }
        case typesafe_actions_1.getType(PlaceAction_1.default.setAddPlaceButtonActive): {
            return __assign(__assign({}, state), { addPlaceActive: action.payload });
        }
    }
    return state;
};
exports.neighbourhoodReducer = neighbourhoodReducer;
